import { render, staticRenderFns } from "./edit-vip.vue?vue&type=template&id=7cdb8204&scoped=true"
import script from "./edit-vip.vue?vue&type=script&lang=js"
export * from "./edit-vip.vue?vue&type=script&lang=js"
import style0 from "./edit-vip.vue?vue&type=style&index=0&id=7cdb8204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdb8204",
  null
  
)

export default component.exports